import pollState from './pollState';
import quizState from './quizState';
import sliderPollState from './sliderPollState';

const engState = {
  data: {
    sliderPoll: sliderPollState,
    poll: pollState,
    quiz: quizState,
  },
  etc: {
    engType: '',
    engStep: 0,
    dynamicFields: 0,
    isEngSubmittable: false,
    creationType: '',
  },
};

export default engState;
